import { useTranslation } from 'react-i18next';
import { formatLanguageLabel, supportedLanguageOptions } from '@sz/l10n';
import { useChangeLocale } from '@/hooks/useChangeLocale';
import styles from './LanguagePicker.module.scss';

export function LanguagePicker() {
  const { i18n } = useTranslation();
  const changeLocale = useChangeLocale();

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    changeLocale(event.target.value);
  };

  const currentShort = (i18n.language || 'en').toUpperCase();

  return (
    <div className={styles.container}>
      <span className={styles.label}>{currentShort} ▾</span>
      <select
        className={styles.select}
        value={i18n.language}
        onChange={handleChange}
        aria-label="Select language"
      >
        {supportedLanguageOptions.map(lang => (
          <option key={lang.value} value={lang.value}>
            {formatLanguageLabel(lang.locale)}
          </option>
        ))}
      </select>
    </div>
  );
}
